import { mentionRegex } from "utils";
import { sanitizePostHtml } from "./sanitizePostHtml";

/**
 * Convert "@name [uid: id]" mention tokens into mention anchors. For legacy
 * plain-text posts only `<a>` survives (unchanged behaviour). For rich-text
 * posts (`rich = true`, #1269) the formatting tags are preserved so bold /
 * lists / images render alongside clickable mentions.
 */
export const convertMentionIntoHref = (
	description: string,
	rich = false,
): string => {
	let source = sanitizePostHtml(description, rich);
	const instances = source.match(mentionRegex);
	instances &&
		instances.map((instance: string) => {
			const parts = instance.split(" [uid: ");

			source = source.replace(
				instance,
				`<a membermentionid="${parts[1].replace("]", "")}">${
					parts[0]
				}</a>`,
			);
			return undefined;
		});

	return source;
};
